module.exports = __webpack_public_path__ + "img/block_4.37d0f28c.webp";